import { render } from "./DeveloperItemDisplay.vue?vue&type=template&id=ec2db6b4"
import script from "./DeveloperItemDisplay.vue?vue&type=script&lang=js"
export * from "./DeveloperItemDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__